import { forwardRef } from 'react';
import MuiButton from '@mui/material/Button';
import MuiIconButton from '@mui/material/IconButton';
import MuiMenuItem from '@mui/material/MenuItem';
import { inferPermissionAction } from 'api/access';
import { useAccessControl } from 'contexts/AccessControlContext';

// Keep MUI behavior and refs while applying the current menu's action access.
function withActionAccess(Component, { menuItem = false } = {}) {
  const Action = forwardRef(function PermissionAction({ permissionAction, children, ...props }, ref) {
    const { can, loading, menuPath } = useAccessControl();
    const action = permissionAction || ((!menuItem || props.onClick)
      ? inferPermissionAction([children, props['aria-label'], props.title])
      : null);
    if (menuPath && action && (loading || !can(action))) return null;
    return <Component ref={ref} {...props}>{children}</Component>;
  });
  Action.muiName = Component.muiName;
  return Action;
}

export const Button = withActionAccess(MuiButton);
export const IconButton = withActionAccess(MuiIconButton);
export const MenuItem = withActionAccess(MuiMenuItem, { menuItem: true });
export const NativeButton = withActionAccess('button');
